import React, { useEffect, useState } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage, StaticImage, getImage } from "gatsby-plugin-image";


const MainLogo = (props) => {
    const logoFiles = useStaticQuery(graphql`
    query Logos {
        logos: allFile(filter: {fields: {holiday: {date: {ne: null}}}}) {
          list: nodes {
            name
            fields {
              holiday {
                date(formatString: "YYYY-MM-DD")
              }
            }
            childImageSharp {
              gatsbyImageData(width: 175, quality: 100)
            }
          }
        }
      }
  `);

    const [logoFile, setLogoFile] = useState(null);

    useEffect(() => {
        // Get today's date
        const today = new Date(); // Test with Christmas 2023-12-25
        const todayMonth = today.getMonth() + 1; // Adding 1 because getMonth() returns zero-based index
        const todayDate = today.getDate();
        const logoImage = logoFiles.logos.list.find(node => {
            const h = node.fields.holiday
            const holiDate = new Date(h.date);
            const holidayDate = holiDate.getDate();
            const holidayMonth = holiDate.getMonth() + 1; // Adding 1 because getMonth() returns zero-based index
            const isHoliday = holidayDate === todayDate && holidayMonth === todayMonth;
            return isHoliday
        });
        if (logoImage) {
            setLogoFile(getImage(logoImage.childImageSharp));
        }
    }, [logoFiles]);

    // Render your component JSX
    const imageClass = "transition-all ease-in-out duration-300 object-contain max-w-[175px] ";
    return (
        <>
            {logoFile && (
                <GatsbyImage
                    alt="Vegas Aces Logo Dynamic"
                    image={logoFile}
                    width={175}
                    loading="eager"
                    placeholder="none"
                    className={[imageClass, props.scroll && " !max-w-[120px]"]}
                />
            )}
            {!logoFile && (
                <StaticImage
                    src="../../assets/media/vegas-aces-logo.png"
                    alt="Vegas Aces Logo Static"
                    width={175}
                    height={50}
                    loading="eager"
                    quality={100}
                    placeholder="none"
                    className={[imageClass, props.scroll && " !max-w-[120px]"]}
                />
            )}
        </>
    );
};

export default MainLogo;
